import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgFilterOutline = function SvgFilterOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4.5C15.6186 4.5 14.5 5.61859 14.5 7C14.5 8.38141 15.6186 9.5 17 9.5C18.3814 9.5 19.5 8.38141 19.5 7C19.5 5.61859 18.3814 4.5 17 4.5ZM13.0701 6.25C13.421 4.3989 15.0465 3 17 3C19.2098 3 21 4.79015 21 7C21 9.20985 19.2098 11 17 11C15.0465 11 13.421 9.6011 13.0701 7.75H3.75C3.33579 7.75 3 7.41421 3 7C3 6.58579 3.33579 6.25 3.75 6.25H13.0701ZM5.07014 16.25C5.421 14.3989 7.04653 13 9 13C10.9535 13 12.579 14.3989 12.9299 16.25H20.25C20.6642 16.25 21 16.5858 21 17C21 17.4142 20.6642 17.75 20.25 17.75H12.9299C12.579 19.6011 10.9535 21 9 21C7.04653 21 5.421 19.6011 5.07014 17.75H3.75C3.33579 17.75 3 17.4142 3 17C3 16.5858 3.33579 16.25 3.75 16.25H5.07014ZM9 14.5C7.6186 14.5 6.5 15.6186 6.5 17C6.5 18.3814 7.6186 19.5 9 19.5C10.3814 19.5 11.5 18.3814 11.5 17C11.5 15.6186 10.3814 14.5 9 14.5Z"
  })));
};

export { SvgFilterOutline as ReactComponent };
//# sourceMappingURL=filter-outline.svg.js.map
